module.exports = __webpack_public_path__ + "static/img/bookingManagement.c494e501.png";